import { Storage } from '~/shared/utils/storage/storage';
import { useLocalStorageString } from '../utils';

export default function useBasketReference() {
    return useLocalStorageString(Storage.basketReference, undefined);
}
